const articleIndexStyle = {
    articlesListContainer: {
        marginTop: '20px'
    },
    article: {
        marginBottom: '40px',
        marginTop: '40px'
    },
    rightPicture: {
        "@media (max-width: 600px)": {
            order: -1
        }
    },
    articleTitle: {
        marginTop: '1rem',
        color: '#3C4858',
        fontWeight: 700
    },
    articleSubTitle: {
        color: '#3C4858',
        fontWeight: 400
    },
    articleSnippet: {
        color: '#000',
        fontSize: '1.0625rem',
        lineHeight: '1.55em',
        marginTop: '10px',
        marginBotton: '10px',
        color: 'inherit',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontWeight: 300
    }
}

export default articleIndexStyle;